jQuery(function() {
    loadCart();
    initCart();
    initButtonChangeQuantityOnProductPage();
    initUpdateQuantityOnCartPage();
    initPromoCodeForm();

});

async function doesDiscountCodeExist(discountCode) {
    const result = await fetch(`/admin/discount_codes/lookup.json?code=${discountCode}`);

    if (result.status == 200) {
        setCookie("discount_code", discountCode, 10);
        document.location.href=document.location.origin + '/discount/' + discountCode + '?redirect=/checkout';
    }
}

function initPromoCodeForm(){
    $('.add-promocode').on('click', function(){
       $(this).hide();
       $('#promocode-form').show();
    });

    $('#apply_promo_code').on('click', function(){
        var customer_promo_code = $('#customer_promo_code').val();
        doesDiscountCodeExist(customer_promo_code);
    });

    var res_cookie = getCookie('discount_code');
    if(res_cookie!='' && res_cookie!=null){
        $('#customer_promo_code_res').text(res_cookie);
        $('#apply_promo_code').hide();
        $('#promo_code_fixed').show();
    }
}

function loadCart() {
    jQuery.ajax({
        type: 'GET',
        url: '/cart.json',
        dataType: 'jsonp',
        success: function(data) {
            var item_count = data['item_count'];
            var total_price = data['total_price']/100;
            var cart_has_subscibe_product = 0;

            if(typeof Shopify.currency.active != 'undefined') {
                var currency = Shopify.currency.active;
            }else {
                var currency = '$';
            }

            //If there are items in cart
            if ( item_count > 0 ) {

                // cart count
                jQuery('.cart-count').text(item_count);

                // mini cart data
                jQuery('.mini-cart').attr('id','mini-cart');
                jQuery('.mini-cart-subtotal').text( currency + total_price.toFixed(2) );


                var cart_list = [];
                var cart_list_cart_page = [];

                for( var i = 0; i < item_count; i++ ){
                    if(data['items'][i]) {
                        if (data['items'][i]['id']) {

                            var item_id = data['items'][i]['id'];
                            var product_title = data['items'][i]['product_title'];
                            var quantity = data['items'][i]['quantity'];
                            var line_price = data['items'][i]['price'] / 100;
                            var final_line_price = data['items'][i]['final_line_price'] / 100;
                            var product_url = data['items'][i]['url'];
                            var image_url = data['items'][i]['image'];
                            var variants = data['items'][i]['variant_options'];
                            var product_oz = Math.ceil(data['items'][i]['grams']/28.34952);

                            var size_value_string = '';
                            if(data['items'][i]['properties']){
                                size_value_string = data['items'][i]['properties']['Size'];
                            }

                            var options = [];
                            for (var o = 0; o < variants.length; o++) {
                                var option = data['items'][i]['variant_options'][o];
                                      options.push('<span>'+ option +'</span>');
                            }
                            var product_options = options.join('');

                            var min_quantity = 1;

                            var html_cart_page = '<div class="cart-page-main-item">' +
                                '      <div class="cart-page-main-item-left">' +
                                '        <a href="'+ product_url +'" class="cart-page-main-item-img"><img src="'+ image_url +'"></a>' +
                                '        <div class="cart-page-main-item-left-info">' +
                                '          <h5><a href="'+ product_url +'">'+ product_title +'</a></h5>' +
                                '          <div class="cart-page-main-item-left-details">' +
                                '            <span>' + size_value_string + '</span>' +
                                            product_options +
                                '          </div>' +
                                '        </div>' +
                                '      </div>' +
                                '      <div class="cart-page-main-item-middle">\n' +
                                '<div class="number-input change_product_count" data-variant="' + data['items'][i]['variant_id'] +'">\n'+
                                '<button class="cart-button-quantity-change icon-minus cart___remove minus"></button>\n'+
                                '<input disabled id="product_quantity_'+ data['items'][i]['variant_id']  +'" min="1" max="99" name="quantity" value="'+ quantity +'" type="number">\n'+
                                '<button class="cart-button-quantity-change icon-plus plus"></button>\n'+
                                '</div>\n'+
                                '      </div>' +
                                '      <div class="cart-page-main-item-middle2">' +
                                '        <span>' + currency + line_price.toFixed(2) +'</span>' +
                                '      </div>' +
                                '      <div class="cart-page-main-item-right">' +
                                '        <span>' + currency + final_line_price.toFixed(2) +'</span>' +
                                '      </div>' +
                                '    </div>';

                            cart_list_cart_page.push(html_cart_page);

                            var html = '<div class="cart-menu-item">\n'+
                                            '<a href="'+ product_url +'" class="cart-menu-img">\n'+
                                                '<img src="'+ image_url +'">\n'+
                                            '</a>\n'+
                                            '<div class="cart-menu-col-middle">\n'+
                                                '<h5><a href="'+ product_url +'">'+ product_title +'</a></h5>\n'+
                                                '<div class="cart-menu-col-middle-details">\n'+
                                                    '<span>'+ size_value_string +'</span>\n'+
                                                    product_options
                                                +'</div>\n'+
                                            '</div>\n'+
                                            '<div class="cart-menu-col-right">\n'+
                                                '<span class="cart-menu-price">' + currency + final_line_price.toFixed(2) +'</span>\n'+
                                                '<div class="number-input change_product_count" data-variant="' + data['items'][i]['variant_id'] +'">\n'+
                                                    '<button class="cart-button-quantity-change icon-minus cart___remove minus"></button>\n'+
                                                    '<input disabled id="product_quantity_'+ data['items'][i]['variant_id']  +'" min="1" max="99" name="quantity" value="'+ quantity +'" type="number">\n'+
                                                    '<button class="cart-button-quantity-change icon-plus plus"></button>\n'+
                                                '</div>\n'+
                                            '</div>\n'+
                                        '</div>\n';
                            cart_list.push(html);
                        } //endif
                    }
                } // endfor


                jQuery('.mini-products-list').html( cart_list.join('') );
                jQuery('#cart-products-list').html( cart_list_cart_page.join('') );

                $('.no-items-in-cart').hide();

                jQuery('.remove-item-from-cart').on('click',function(){
                    var product_variant_id = $(this).attr('data-productId');
                    $(this).parent().parent().parent().parent().parent().remove();
                    removeItemCountInCart(product_variant_id,0);
                });

                jQuery('.cart-button-quantity-change').on('click', function(){
                    // $('.mini-cart-block').hide();
                    // $('.loadingCart').show();

                    var product_variant_id = $(this).closest('.change_product_count').attr('data-variant');
                    var current_element_quantity = parseInt($('#product_quantity_' + product_variant_id).val());

                    if($(this).hasClass('icon-plus')) {
                        var new_element_quantity = current_element_quantity + 1;
                        updateItemCountInCart(product_variant_id, new_element_quantity);
                        $('#product_quantity_' + product_variant_id).val(new_element_quantity);
                    }else{
                        var new_element_quantity = current_element_quantity - 1;
                        removeItemCountInCart(product_variant_id, new_element_quantity);
                        $('#product_quantity_' + product_variant_id).val(new_element_quantity);
                    }
                });

                // $('.mini-cart-block').show();
                 $('.loadingCart').hide();
            }else{
                $('.loadingCart').hide();
                $('.mini-products-list').empty().show();
                $('.no-items-in-cart').show();
                $('.mini-cart-subtotal').text('');
            }
        }
    });
}

function initCart() {

    var total_items_in_cart = 0;

    jQuery.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(data) {

            var item_counts_in_cart = data.items.length;
            total_items_in_cart = data.item_count;

            if(item_counts_in_cart>0) {
                 var products_in_cart = data.items.length;

                 jQuery('.cart-menu-button span').text(total_items_in_cart);
                 jQuery('.total_items').text(total_items_in_cart);

                 $('#header_cart_quantity').show().text(data.items.length);
                 $('#small_cart_elements_count').text(products_in_cart);
                 $('.no-items-in-cart, .small-cart-empty').hide();
                 $('.small-cart-checkout-button, .mini-cart-block').show();
            }else{
                 $('.no-items-in-cart, .small-cart-empty').show();
                 $('#header_cart_quantity').text(0);
                 $('.mini-products-list').empty();
                 $('#small_cart_elements_count, .mini-cart-subtotal').text('');
                 $('.mini-cart-block, .small-cart-checkout-button').hide();
            }
        }
    });
}

function initButtonChangeQuantityOnProductPage() {
    $('.icon-minus').addClass('no-active');

    $('.button-quantity-change').on('click', function(){
        var product_id = $(this).data('product-id');
        var selected_qty = parseInt($('#product_quantity_' + product_id).val());
        var new_qty = selected_qty * 1;
        var min_qty = 1;
        var max_qty = 99;

        if($(this).hasClass('icon-plus')) {
            new_qty++;
        }else{
            if(new_qty>1) {
                new_qty--;
            }
        }

        if(new_qty==min_qty){
            $('.icon-minus').addClass('no-active');
        }else{
            $('.icon-minus').removeClass('no-active');
        }

        $('#product_quantity_' + product_id).val(new_qty);

        if(max_qty==new_qty) {
            $('.icon-plus').hide();
        }else{
            $('.icon-plus').show();
        }

        var product_price = parseInt($('#product-variant-price').data('product-price'));
        var new_price = (product_price * new_qty)/100;
        $('#product-variant-price').text('$'+ new_price.toFixed(2));
    });
}

function removeItemCountInCart(variant_id,new_count, reload) {

    var data = {
        'id': variant_id,
        'quantity': new_count
    }
    jQuery.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: data,
        dataType: 'json',
        success: function(data) {
            initCart();
            loadCart();
            if(reload == 1 || document.location.pathname=='/cart'){
                document.location.reload();
            }
        },
        error: function(error) {
            alert(error.responseJSON.message + '\r\n' + error.responseJSON.description);
            initCart();
            loadCart();
        }

    });
}

function initUpdateQuantityOnCartPage(){
    $('.cart-quantity-update').on('click', function(){
        $('.cart-loading').show();
        $('.product-cart-row').hide();

        var product_id = $(this).data('product_id');
        var variant_id = $('#cart_product_variant_id_' + product_id).val();

        var current_element_quantity = parseInt($('#product_selected_quantity_' + product_id).val());

        if($(this).hasClass('icon-plus')) {
            updateItemCountInCart(variant_id, current_element_quantity, '', '', 1);
        }else{
            if($(this).hasClass('delete-item-from-cart')){
                current_element_quantity = 0;
            }
            removeItemCountInCart(variant_id, current_element_quantity, 1);
        }

    });
}

function updateItemCountInCart(variant_id, new_count, reload) {

        var data = {
            "id": variant_id,
            "quantity": new_count
        }

        jQuery.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: data,
            dataType: 'json',
            success: function(data) {
                initCart();
                loadCart();
                if(reload == 1 || document.location.pathname=='/cart'){
                    document.location.reload();
                }
            },
            error: function(error) {
                alert(error.responseJSON.message + '\r\n' + error.responseJSON.description);
                initCart();
                loadCart();
            }
        });

}

// function showSmallCart(){
//     $('.cart-menu-button').click();
// }

function addItemToCart(product_id) {

    var qty = parseInt($('#product_quantity_'+ product_id).val());
    var variant_id = $('#product_id_'+ product_id).attr('data-variant-id');
    var product_size_value = $('#product_size_value_' + product_id).val();

    if(variant_id == 0 || variant_id == ''){
        $('.aside-shop__sizes-error').fadeIn(700);
        $('.aside-shop__sizes ').addClass('error');
    }else {

        if (!qty) {
            qty = 1;
        }

        if(product_size_value!=''){
            var data = {
                "id": variant_id,
                "quantity": qty,
                "properties" : {
                    'Size': product_size_value
                }
            }
        }else {
            var data = {
                "id": variant_id,
                "quantity": qty
            }
        }

        window.dataLayer.push({
            event: 'ee_addToCart',
            product_name: $('#product_id_'+ product_id).attr('data-ptitle'),
            product_id : $('#product_id_'+ product_id).attr('data-pid'),
            product_price: $('#product_id_'+ product_id).attr('data-pprice'),
            product_brand: $('#product_id_'+ product_id).attr('data-pbrand'),
            currency: Shopify.currency.active,
            product_type: $('#product_id_'+ product_id).attr('data-ptype'),
            category_id: $('#product_id_'+ product_id).attr('data-pcategory_id'),
            category_title: $('#product_id_'+ product_id).attr('data-pcategory_name'),
            variant_id: $('#product_id_'+ product_id).attr('data-variant-id'),
            variant_title: $('#product_id_'+ product_id).attr('data-pvtitle'),
            product_sku: $('#product_id_'+ product_id).attr('data-psku'),
            quantity: qty
        });

        jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function () {
                initCart();
                loadCart();
                window.monster_refresh(open);
                toggleCart();
                // showSmallCart();
            },
            error: function (error) {
                alert(error.responseJSON.message + '\r\n' + error.responseJSON.description);
            }
        });
    }
}

function addSubscribeItemToCart(variant_id, product_id) {

    if(product_id>0){
        var qty = parseInt($('#product_block_index_' + product_id + ' .product_selected_quantity').val());
        var properties = $('#product_block_index_' + product_id + ' .product_extra_properties').val();
        var selling_plan = $('#product_block_index_' + product_id + ' input[name="selling_plan"]').val();
        var min_quantity = $('#product_min_quantity_' + product_id).val();
    }else {
        var qty = parseInt($('#product_selected_quantity').val());
        var properties = $('.product_extra_properties').val();
        var selling_plan = $('input[name="selling_plan"]').val();
        var min_quantity = $('.product_min_quantity').val();
    }

    if(!qty){
        qty = 1;
    }

    if(qty<min_quantity){
        qty = min_quantity;
    }

    setTimeout(function() {
        if(properties!='') {
            var data = {
                "id": variant_id,
                "quantity": qty,
                "selling_plan": selling_plan,
                "properties": { properties }
            }
        }else{
            var data = {
                "id": variant_id,
                "quantity": qty,
                "selling_plan": selling_plan
            }
        }

        jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function () {
                initCart();
                loadCart();
                window.monster_refresh(open);
                toggleCart();
                // showSmallCart();
            },
            error: function(error) {
                alert(error.responseJSON.message + '\r\n' + error.responseJSON.description);
            }
        });
    }, 100);

}

function quickAddItemToCart(product_id) {

    var variant_id = $('#product_id_'+ product_id).attr('data-variant-id');
    var product_size_value = $('#product_size_value_' + product_id).val();

    if(product_size_value!=''){
        var data = {
            "id": variant_id,
            "quantity": 1,
            "properties" : {
                'Size': product_size_value
            }
        }
    }else {
        var data = {
            "id": variant_id,
            "quantity": 1
        }
    }

    window.dataLayer.push({
        event: 'ee_addToCart',
        product_name: $('#product_id_'+ product_id).attr('data-ptitle'),
        product_id : $('#product_id_'+ product_id).attr('data-pid'),
        product_price: $('#product_id_'+ product_id).attr('data-pprice'),
        product_brand: $('#product_id_'+ product_id).attr('data-pbrand'),
        currency: Shopify.currency.active,
        product_type: $('#product_id_'+ product_id).attr('data-ptype'),
        category_id: $('#product_id_'+ product_id).attr('data-pcategory_id'),
        category_title: $('#product_id_'+ product_id).attr('data-pcategory_name'),
        variant_id: $('#product_id_'+ product_id).attr('data-variant-id'),
        variant_title: $('#product_id_'+ product_id).attr('data-pvtitle'),
        product_sku: $('#product_id_'+ product_id).attr('data-psku'),
        quantity: 1
    });

    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function() {
            if(document.location.pathname=='/cart'){
                document.location.reload();
            }else{
                initCart();
                loadCart();
                window.monster_refresh(open);
                toggleCart();
                // showSmallCart();
            }
        },
        error: function(error) {
            alert(error.responseJSON.message + '\r\n' + error.responseJSON.description);
        }
    });
}

const urlParams = new URLSearchParams(window.location.search);

if (document.location.pathname === '/cart') {
    window.location.replace('/?show-cart');
}

if (urlParams.has('show-cart')) {
    const checkCartReady = setInterval(() => {
        if (document.querySelector('#monster-upsell-cart')) {
            window.monster_refresh(open);
            toggleCart();
            clearInterval(checkCartReady);
        }
    }, 200);
}

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}


function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');

    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
